import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { ShoppingCart, Smartphone, Users, TrendingUp } from 'lucide-react';

const RetailServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Retail & Consumer Goods Solutions | AuVSys</title>
        <meta name="description" content="Transform retail experiences with omnichannel solutions, personalization, and digital commerce platforms." />
      </Helmet>

      <div className="retail-services">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Retail & Consumer Goods</h1>
              <p>Transform retail experiences with omnichannel solutions, AI-powered personalization, and next-generation digital commerce platforms.</p>
            </div>
          </div>
        </section>

        <section className="services-grid">
          <div className="container">
            <div className="grid">
              <div className="service-card">
                <ShoppingCart className="service-icon" />
                <h3>E-commerce Platforms</h3>
                <p>Scalable digital commerce solutions with integrated payment and inventory management.</p>
              </div>
              <div className="service-card">
                <Smartphone className="service-icon" />
                <h3>Mobile Commerce</h3>
                <p>Native mobile apps and progressive web applications for seamless shopping experiences.</p>
              </div>
              <div className="service-card">
                <Users className="service-icon" />
                <h3>Customer Analytics</h3>
                <p>AI-driven customer insights and personalization engines to boost engagement.</p>
              </div>
              <div className="service-card">
                <TrendingUp className="service-icon" />
                <h3>Inventory Optimization</h3>
                <p>Smart inventory management with demand forecasting and supply chain optimization.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RetailServices;